import { graphql } from '@tn/foundation/graphql/__generated/gql';

export const bindMvpdDocument = /* GraphQL */ `
    mutation BindMvpd($fields: BindMvpdFields!) {
        bindMvpd(fields: $fields) {
            success
        }
    }
`;
export const bindMvpdMutation = graphql(bindMvpdDocument);
